import Cookies from "universal-cookie";
import { getNSWToken } from "../components/dashboard/pages/search-query-tool/data-service";

class ServiceAuth {
    expireDuration = 3600000;
    nswTokenExpire = 43199000;

    cookies = new Cookies();

    setFirebase(fb) {
        this.firebase = fb;
    }

    setAuthInfo(token) {
        this.cookies.set("token", token, { path: "/", expires: new Date(Date.now() + this.expireDuration) });
        this.cookies.set("authenticated", true, { path: "/", expires: new Date(Date.now() + this.expireDuration) });
    }
    setUID(uid) {
        this.cookies.set("uid", uid, { path: "/", expires: new Date(Date.now() + this.expireDuration) });
    }
    setEmailInfo(email) {
        this.cookies.set("email", email, { path: "/", expires: new Date(Date.now() + this.expireDuration) });
    }

    setNSWAccessToken(token) {
        this.cookies.remove("nsw_access_token");
        this.cookies.set("nsw_access_token", token, { path: "/", expires: new Date(Date.now() + this.nswTokenExpire) });
    }

    setOrgId(orgId) {
        this.cookies.remove("di_o", { path: "/" });
        if (orgId) {
            let encodedOrgId = Buffer.from(orgId).toString("base64");
            let decodedOrgId = Buffer.from(encodedOrgId, "base64").toString();
            //console.log(orgId, encodedOrgId, decodedOrgId);
            this.cookies.set("di_o", encodedOrgId, { path: "/" });
        }
    }

    setaXNzdXBlcmFkbWlu(value) {
        this.cookies.set("aXNzdXBlcmFkbWlu", value, { path: "/", expires: new Date(Date.now() + this.expireDuration) });
    }

    // todo logout if token expired
    getToken() {
        if(this.cookies.get("authenticated") !== "true"){
            window.location.reload();
        }
        return this.cookies.get("token");
    }

    getOrgId() {
        if(this.cookies.get("di_o")){
            let decodedOrgId = Buffer.from(this.cookies.get("di_o"), "base64").toString();
            return decodedOrgId;
        } else {
            return "";
        }
    }

    getEmailInfo() {
        return this.cookies.get("email");
    }

    getUID() {
        return this.cookies.get("uid");
    }

    async getNSWAccessToken() {
        let tokenValid = false;
        let nswToken = this.cookies.get("nsw_access_token");

        if (nswToken) {
            tokenValid = true;
        }

        if (!tokenValid) {
            const [res, nswTokenError] = await getNSWToken();
            if (nswTokenError) {
                return [null,nswTokenError];
            } else {
                nswToken = res.access_token ;
                this.setNSWAccessToken(nswToken);
            }
        }
        
        return [nswToken,""];
    }

    getaXNzdXBlcmFkbWlu() {
        return this.cookies.get("aXNzdXBlcmFkbWlu");
    }

    // setSubscriptionData(subscriptionData) {
    //     this.cookies.set("subscriptionData", subscriptionData);
    // }

    // getSubscriptionData() {
    //     return this.cookies.get("subscriptionData");
    // }
}

export default new ServiceAuth();
